/**
 * @var jQuery
 * @var SUGGEST_API_URL
 * @var SUGGEST_SHOW_MORE_MESSAGE
 * @var SUGGEST_LOADING_MESSAGE
 * @var SUGGEST_NOT_FOUND_MESSAGE
 * @var SUGGEST_GROUP_PRODUCTS
 * @var SUGGEST_GROUP_CATEGORIES
 * @var SUGGEST_GROUP_POSTS
 */

// WooCommerce single product configuration.
if ( typeof wc_single_product_params !== "object" ) {
    wc_single_product_params = {};
}

wc_single_product_params.zoom_enabled = false;

// Helper variable to check if the last click was
// on "load more products" button or on pagination item.
var wexpress_lmp_pagination_clicked = false;

/**
 * Function called when "Load more products" AJAX finishes.
 */
var wexpress_lmp_after_load = function() {
    if ( ! wexpress_lmp_pagination_clicked ) {
        return;
    }

    var admin_bar = jQuery( "#wpadminbar" );
    var offset    = ( jQuery( "div.products" ).offset().top - 32 );

    if ( admin_bar.length > 0 && screen.width >= 600 ) {
        offset -= admin_bar.outerHeight();
    }

    jQuery( "html, body" ).animate( { scrollTop: offset }, 500 );
};


( function ( $ ) {
    // Bootstrap breakpoints.
    var breakpoints = {
        sm:  576,
        md:  768,
        lg:  992,
        xl:  1200,
        xxl: 1550
    };

    /**
     * Initializes common slider.
     * @param {jQuery} selector   Slider selector.
     * @param {number} items      Base count of items per slide.
     * @param {number} margin     Spacing between items.
     * @param {object} responsive Responsive rules.
     */
    var initialize_slider = function (
        selector,
        items,
        margin,
        responsive
    ) {
        // noinspection JSUnresolvedFunction
        selector.owlCarousel( {
            items: items,
            margin: margin,
            loop: false,
            rewind: true,
            autoplay: false,
            mouseDrag: false,
            touchDrag: true,
            pullDrag: false,
            freeDrag: false,
            nav: true,
            navText: [ "&#x276E;", "&#x276F;" ],
            dots: false,
            responsive: responsive
        } );
    };

    /**
     * Initializes products slider.
     * @param {jQuery} selector
     */
    var initialize_products_slider = function ( selector ) {
        selector.each( function () {
            var slider = $( this );

            var responsive             = {};
            responsive[breakpoints.sm] = { items: 2 };

            if (
                ! $( document.body ).hasClass( "sidebar" )
                || slider.parents( ".site-content" ).length === 0
            ) {
                responsive[breakpoints.lg] = { items: 3 };
                responsive[breakpoints.xl] = { items: 4 };
            } else {
                responsive[breakpoints.xl] = { items: 3 };
            }

            initialize_slider( slider, 1, 40, responsive );
        } );
    };

    // Add "im-loaded" class to body when the document is ready.
    $( document ).ready( function () {
        setTimeout( function () {
            $( document.body ).addClass( "im-loaded" );
        }, 1000 );
    } );

    // Header info bar slider.
    ( function () {
        var info_bar_container = $( "#site-header-info-bar-container" );
        var info_bar_widgets   = info_bar_container.find( ".widget" );

        if ( info_bar_widgets.length < 2 ) {
            return;
        }

        var info_bar_responsive = {};
        info_bar_responsive[breakpoints.md] = { items: 2 };
        info_bar_responsive[breakpoints.lg] = { items: 3 };

        info_bar_container.owlCarousel( {
            items: 1,
            loop: false,
            rewind: true,
            autoplay: true,
            autoplayTimeout: 2500,
            autoplayHoverPause: false,
            mouseDrag: false,
            touchDrag: true,
            pullDrag: false,
            freeDrag: false,
            nav: false,
            dots: false,
            responsive: info_bar_responsive
        } );
    } )();

    // Search suggest.
    (function () {
        var search_form  = document.getElementById( "site-search" );
        var search_input = document.getElementById( "site-search-input" );

        if ( ! search_form || ! search_input ) {
            return;
        }

        new SearchSuggest( SUGGEST_API_URL, search_form, search_input, {
            showMoreMessage: SUGGEST_SHOW_MORE_MESSAGE,
            loadingMessage:  SUGGEST_LOADING_MESSAGE,
            notFoundMessage: SUGGEST_NOT_FOUND_MESSAGE,
            productsGroup:   SUGGEST_GROUP_PRODUCTS,
            categoriesGroup: SUGGEST_GROUP_CATEGORIES,
            postsGroup:      SUGGEST_GROUP_POSTS
        } );
    })();

    // Virtual navigation on phones.
    (function () {
        // Execute only on phones and tablets.
        if ( screen.width >= breakpoints.xl ) {
            return;
        }

        // Build an array of real navigations.
        var navigations = [];

        // Horizontal products menu.
        var products_menu = $( "#site-header-menu .products-menu, #site-sidebar .products-menu" );

        if ( products_menu.length > 0 ) {
            navigations.push( new VirtualNavigationNav(
                products_menu.first(),
                "highlighted"
            ) );
        }

        // Header bar and sidebar navigations.
        $( "#site-header-bar .navigation, #site-sidebar .navigation" ).each( function () {
            navigations.push( new VirtualNavigationNav( $( this ), null ) );
        } );

        // Initialize virtual navigation.
        var header             = $( "#site-header" );
        var phone_navigation   = $( "#site-header-menu-phone" );
        var virtual_navigation = new VirtualNavigation(
            phone_navigation,
            $( "#site-hamburger" ),
            navigations
        );

        virtual_navigation.initialize();

        virtual_navigation.onVisibleChange.push( function ( visible ) {
            var height;
            var admin_bar = $( "#wpadminbar" );

            if ( visible ) {
                height = ( window.innerHeight - header.outerHeight() );

                if ( admin_bar.length > 0 ) {
                    height -= admin_bar.outerHeight();
                }
            } else {
                height = 0;
            }

            phone_navigation.css( { height: height + "px" } );
        });
    })();

    // Products menu in sidebar.
    $( ".site-main .site-sidebar .products-menu ul li .expander" ).on( "click", function () {
        $( this ).parent().toggleClass( "expanded" );
    } );

    // Horizontal filters.
    $( document ).on( "click", ".filters-horizontal .bapf_sfilter", function () {
        $( this ).toggleClass( "active" );
    } );

    // Modals.
    ( function () {
        /**
         * Opens / closes modal.
         * @param {string}  name
         * @param {boolean} visible
         */
        var set_modal_visibility = function ( name, visible ) {
            var modal = $( ".modal[data-modal='" + name + "']" );

            if ( modal.length === 0 ) {
                return;
            }

            if ( visible ) {
                modal.addClass( "active" );
                $( document.body ).addClass( "modal-open" );
            } else {
                modal.removeClass( "active" );
                $( document.body ).removeClass( "modal-open" );
            }
        };

        // Open modal when open element clicked.
        $( ".modal-open" ).on( "click", function () {
            var button = $( this );

            if ( ! button.hasClass( "disabled" ) ) {
                set_modal_visibility( button.data( "modal" ), true );
            }
        } );

        // Close modal when close icon clicked.
        $( ".modal-close" ).on( "click", function () {
            var modal_name = $( this ).closest( ".modal" ).data( "modal" );
            set_modal_visibility( modal_name, false );
        } );

        // Close modal when backdrop clicked.
        $( ".modal" ).on( "click", function ( event ) {
            var target = $( event.target );

            if ( target.hasClass( "modal" ) ) {
                set_modal_visibility( target.data( "modal" ), false );
            }
        } );
    } )();

    // Product cards.
    $( document ).on( "click", ".quantity .quantity-control", function () {
        // Find input.
        var control = jQuery( this );
        var input   = control.parent().find( "input.qty" );
        var button  = control
            .parent()
            .parent()
            .parent()
            .find( "a.add_to_cart_button[data-quantity]" );

        if ( input.length === 0 ) {
            return;
        }

        // Get input parameters.
        var actual = parseInt( input.val() ) || 1;
        var min    = parseInt( input.attr("min") ) || null;
        var max    = parseInt( input.attr("max") ) || null;
        var step   = parseInt( input.attr("step") ) || 1;
        var new_value;

        // Increase / decrease value.
        if ( control.attr( "data-action" ) === "increase" ) {
            new_value = ( actual + step );

            if ( max !== null && new_value > max ) {
                new_value = max;
            }
        } else {
            new_value = ( actual - step );

            if ( min !== null && new_value < min ) {
                new_value = min;
            }
        }

        // Set value to input and button.
        input.val( new_value );
        input.trigger( "input" );

        if ( button.length > 0 ) {
            button.attr( "data-quantity", new_value );
        }
    } );
    
    // On click on anything...
    $( document ).on( "click", function () {
        wexpress_lmp_pagination_clicked = false;
    } );

    // On products pagination click....
    $( document ).on( "click", ".woocommerce-pagination > ul > li > a", function () {
        setTimeout( function () {
            wexpress_lmp_pagination_clicked = true;
        }, 25 );
    } );

    // Flexible content.
    ( function () {
        if ( ! document.body.classList.contains( "page-template-flexible-content" ) ) {
            return;
        }

        // Sliders.
        $( ".flex-block-slider .slider" ).owlCarousel( {
            items: 1,
            loop: false,
            rewind: true,
            autoplay: true,
            autoplayTimeout: 7500,
            autoplayHoverPause: false,
            mouseDrag: false,
            touchDrag: true,
            pullDrag: false,
            freeDrag: false,
            nav: true,
            navText: [ "&#x276E;", "&#x276F;" ],
            dots: false,
        } );

        // Products sliders.
        initialize_products_slider( $( ".flex-block-products-slider .products" ) );

        // Posts sliders.
        var posts_sliders = $( ".flex-block-posts-slider .block-posts" );

        posts_sliders.each( function () {
            var posts_slider = $( this );

            var posts_slider_responsive             = {};
            posts_slider_responsive[breakpoints.md] = { items: 2 };

            if (
                ! $( document.body ).hasClass( "sidebar" )
                || posts_slider.parents( ".site-content" ).length === 0
            ) {
                posts_slider_responsive[breakpoints.xl] = { items: 3 };
            }

            initialize_slider( posts_slider, 1, 40, posts_slider_responsive );
        } );

        // Maps.
        var initMap = function($el) {
            // Find marker elements within map.
            var $markers = $el.find('.marker');

            // Create gerenic map.
            var mapArgs = {
                zoom:              $el.data('zoom') || 16,
                mapTypeId:         google.maps.MapTypeId.ROADMAP,
                zoomControl:       true,
                mapTypeControl:    false,
                scaleControl:      false,
                streetViewControl: true,
                rotateControl:     false,
                fullscreenControl: true
            };
            var map = new google.maps.Map( $el[0], mapArgs );

            // Add markers.
            map.markers = [];
            $markers.each(function(){
                initMarker( $(this), map );
            });

            // Center map based on markers.
            centerMap( map );

            // Return map instance.
            return map;
        }

        var initMarker = function($marker, map) {
            // Get position from marker.
            var lat = $marker.data('lat');
            var lng = $marker.data('lng');
            var latLng = {
                lat: parseFloat( lat ),
                lng: parseFloat( lng )
            };

            // Create marker instance.
            var marker = new google.maps.Marker({
                position : latLng,
                map: map
            });

            // Append to reference for later use.
            map.markers.push( marker );

            // If marker contains HTML, add it to an infoWindow.
            if( $marker.html() ){

                // Create info window.
                var infowindow = new google.maps.InfoWindow({
                    content: $marker.html()
                });

                // Show info window when marker is clicked.
                google.maps.event.addListener(marker, 'click', function() {
                    infowindow.open( map, marker );
                });
            }
        }

        var centerMap = function(map) {
            // Create map boundaries from all map markers.
            var bounds = new google.maps.LatLngBounds();
            map.markers.forEach(function( marker ){
                bounds.extend({
                    lat: marker.position.lat(),
                    lng: marker.position.lng()
                });
            });

            // Case: Single marker.
            if( map.markers.length === 1 ){
                map.setCenter( bounds.getCenter() );

                // Case: Multiple markers.
            } else{
                map.fitBounds( bounds );
            }
        }

        $( ".acf-map" ).each( function() {
            var map = initMap( $(this) );
        } );

        // Categories tiles.
        ( function () {
            /**
             * Called when category tile activation event is triggered.
             * @param {Event} event
             */
            function on_category_tile_activation_event( event ) {
                const $target = event.currentTarget;
                const $tile   = ( $target && ! $target.classList.contains( "category-tile" ) )
                    ? event.currentTarget.closest( ".category-tile" )
                    : event.currentTarget;

                if ( $tile ) {
                    $tile.classList.add( "-active" );

                    setTimeout( function () {
                        if ( $tile.classList.contains( "-active" ) ) {
                            $tile.classList.add( "-ready" );
                        }
                    }, 250 );
                }
            }

            /**
             * Called when category tile deactivation event is triggered.
             * @param {Event} event
             */
            function on_category_tile_deactivation_event( event ) {
                const $target = event.currentTarget;
                const $tile   = ( $target && ! $target.classList.contains( "category-tile" ) )
                    ? event.currentTarget.closest( ".category-tile" )
                    : event.currentTarget;

                if ( $tile ) {
                    $tile.classList.remove( "-active" );
                    $tile.classList.remove( "-ready" );
                }
            }

            // Initialize the tiles.
            const $categories_tiles = document.querySelectorAll( ".categories-tiles .category-tile" );

            for ( const $tile of $categories_tiles ) {
                const $tile_front = $tile.querySelector( ".category-tile-front" );
                $tile_front.addEventListener( "click", on_category_tile_activation_event );
                $tile_front.addEventListener( "mouseenter", on_category_tile_activation_event );
                $tile.addEventListener( "mouseleave", on_category_tile_deactivation_event );
            }
        } )();
    } )();

    // Product archive / category / tag - Order form autosubmit.
    $( document ).on( "change", "#woocommerce-ordering-radio input[type='radio']", function () {
        $( "#woocommerce-ordering-radio" )[0].submit();
    } );

	// Product archive / category / tag - Description content expander.
	( function () {
		var $term_descriptions = document.querySelectorAll( ".term-description" );

		for ( var i = 0; i < $term_descriptions.length; i++ ) {
			var $description = $term_descriptions[i];
			$description.contentExpander = new IM_Content_Expander( $description );
			$description.contentExpander.initialize();
		}
	} )();

    // Single product.
    $( document ).ready( function () {
        if ( ! document.body.classList.contains( "single-product" ) ) {
            return;
        }

        // Photo gallery slider.
        // On some e-shops, gallery isn't loaded immediately, so we have to wait some time.
        ( function () {
            function initialize_gallery_slider( slider ) {
                var gallery_responsive             = {};
                gallery_responsive[breakpoints.sm] = { items: 4 };
                gallery_responsive[breakpoints.md] = { items: 3 };

                if ( ! $( document.body ).hasClass("sidebar") ) {
                    gallery_responsive[breakpoints.lg] = { items: 4 };
                }

                initialize_slider( slider, 3, 20, gallery_responsive );
            }

            var gallery_slider = $( "div.product .images .flex-control-nav" );

            if ( gallery_slider.length > 0 ) {
                initialize_gallery_slider( gallery_slider );
            } else {
                setTimeout( function () {
                    gallery_slider = $( "div.product .images .flex-control-nav" );

                    if ( gallery_slider.length > 0 ) {
                        initialize_gallery_slider( gallery_slider );
                    }
                }, 250 );
            }
        } )();

        // Close gallery on background click.
        $( document ).on( "click", ".pswp__container", function ( event ) {
            if ( ! $( event.target ).hasClass( "pswp__img" )  ) {
                $( this ).parent().find( ".pswp__button.pswp__button--close" ).trigger( "click" );
            }
        } );

        $( document ).on( "click", ".pswp__top-bar", function ( event ) {
            if ( $( event.target ).hasClass( "pswp__top-bar" )  ) {
                $( this ).find( ".pswp__button.pswp__button--close" ).trigger( "click" );
            }
        } );

        // Move product tags into flex-viewport.
        ( function () {
            var product_images = $( "div.product .images" );
            var product_tags   = product_images.find( ".product-tags" );
            var flex_viewport  = product_images.find( ".flex-viewport" );

            if ( product_tags.length > 0 && flex_viewport.length > 0 ) {
                product_tags.appendTo(flex_viewport);
            }
        } )();

        // Set variation permalink on select.
        $( "input.variation_id[type='hidden'][name='variation_id']" ).on( "change", function () {
            var value = parseInt( $( this ).val() );

            if (
                isNaN( value )
                || typeof wexpress_product_children_permalinks !== "object"
                || typeof wexpress_product_children_permalinks[ value ] !== "string"
            ) {
                return;
            }

            var permalink     = wexpress_product_children_permalinks[ value ];
            var permalinkUrl  = new URL( permalink, window.location.origin );
            var currentParams = new URLSearchParams( window.location.search );

            currentParams.forEach( function ( val, key ) {
                if ( ! permalinkUrl.searchParams.has( key ) ) {
                    permalinkUrl.searchParams.set( key, val );
                }
            } );

            window.history.replaceState( null, document.title, permalinkUrl.toString() );
        } );
        
        // Disable scroll events on product detail
        // (because of Load more products plugin rewriting URL using History API).
        $( document ).on( "scroll", function ( event ) {
            event.stopPropagation();
        } );

        // Upsells & related products sliders.
        ( function () {
            var upsells_related_slider = $( "div.product" )
                .find(".upsells, .related")
                .find(".products");

            initialize_products_slider( upsells_related_slider );
        } )();
    } );

    // Searching.
    ( function () {
        if ( ! document.body.classList.contains( "search" ) ) {
            return;
        }

        // Categories form autosubmit.
        var category_radio_form = $( "#search-form-categories" );
        category_radio_form.find("input[type='radio']").on( "change", function () {
            category_radio_form[0].submit();
        } );
    } )();

    // Images carousel widget.
    ( function () {
        var $carousels = $( ".widget_im-images-carousel .images-carousel" );

        var carousel_responsive = {};
        carousel_responsive[breakpoints.sm] = { items: 3 };
        carousel_responsive[breakpoints.md] = { items: 4 };
        carousel_responsive[breakpoints.lg] = { items: 5 };
        carousel_responsive[breakpoints.xxl] = {
            items: 5,
            margin: 50
        };

        $carousels.owlCarousel( {
            items: 2,
            margin: 25,
            loop: true,
            rewind: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: false,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: false,
            freeDrag: false,
            nav: false,
            dots: false,
            responsive: carousel_responsive
        } );
    } )();

    // Dropdown widget.
    ( function () {
        $( ".im-dropdown .im-dropdown-current" ).on( "click", function ( event ) {
            event.stopPropagation();

            $( event.currentTarget )
                .parent()
                .toggleClass( "-active" );
        } );

        $( ".im-dropdown .im-dropdown-menu" ).on( "click", function ( event ) {
            event.stopPropagation();
        } );

        $( document ).on( "click", function () {
            $( ".im-dropdown.-active" ).removeClass( "-active" );
        } );
    } )();
} )( jQuery );
